"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

var _jspdf = require("jspdf");

var _reactRedux = require("react-redux");

var _actions = require("../../actions");

var _InlineSvg = _interopRequireDefault(require("../../../components/InlineSvg"));

var _newPage = _interopRequireDefault(require("../../../../pdfpages/new-page01-80.jpg"));

var _newPage2 = _interopRequireDefault(require("../../../../pdfpages/new-page02-80.jpg"));

var _newPage3 = _interopRequireDefault(require("../../../../pdfpages/new-page03-80.jpg"));

var _newPage4 = _interopRequireDefault(require("../../../../pdfpages/new-page04-80.jpg"));

var _newPage5 = _interopRequireDefault(require("../../../../pdfpages/new-page05-80.jpg"));

var _newPage6 = _interopRequireDefault(require("../../../../pdfpages/new-page06-80.jpg"));

var _newPage7 = _interopRequireDefault(require("../../../../pdfpages/new-page07-80.jpg"));

var _newPage8 = _interopRequireDefault(require("../../../../pdfpages/new-page08-80.jpg"));

var _newPage9 = _interopRequireDefault(require("../../../../pdfpages/new-page09-80.jpg"));

var _newPage10 = _interopRequireDefault(require("../../../../pdfpages/new-page10-80.jpg"));

var _newPage11 = _interopRequireDefault(require("../../../../pdfpages/new-page11-80.jpg"));

var _newPage12 = _interopRequireDefault(require("../../../../pdfpages/new-page12-80.jpg"));

var _newPage13 = _interopRequireDefault(require("../../../../pdfpages/new-page13-80.jpg"));

var _newPage14 = _interopRequireDefault(require("../../../../pdfpages/new-page14-80.jpg"));

var _newPage0280Nz = _interopRequireDefault(require("../../../../pdfpages/new-page02-80-nz.jpg"));

var _newPage1080Nz = _interopRequireDefault(require("../../../../pdfpages/new-page10-80-nz.jpg"));

var _newPage1180Nz = _interopRequireDefault(require("../../../../pdfpages/new-page11-80-nz.jpg"));

var _newPage1280Nz = _interopRequireDefault(require("../../../../pdfpages/new-page12-80-nz.jpg"));

var _newPage1380Nz = _interopRequireDefault(require("../../../../pdfpages/new-page13-80-nz.jpg"));

var _newPage1480Nz = _interopRequireDefault(require("../../../../pdfpages/new-page14-80-nz.jpg"));

var _helpers = require("../../../helpers");

var _ProximaNovaBold = require("../../../assets/fonts/ProximaNova-bold");

var _ProximaNovaRegularNormal = require("../../../assets/fonts/ProximaNova-Regular-normal");

var _helpers2 = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function PDFHandler(_ref) {
  var disabled = _ref.disabled,
      indexThreshold = _ref.indexThreshold,
      name = _ref.name,
      quadId = _ref.quadId;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.universes;
  }),
      currentUniverse = _useSelector.currentUniverse;

  function handlePDFGen(_x, _x2) {
    return _handlePDFGen.apply(this, arguments);
  }

  function _handlePDFGen() {
    _handlePDFGen = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(event, data) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch((0, _actions.getQuadrantMessagesDownload)(quadId, indexThreshold, currentUniverse)).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(response) {
                  var percentage, sections, pdf, width, height, copyInitialX, copyInitialY, bg1, bg2, currentY, bg3, section, bg4, bg5, bg6, bg7, bg8, bg9, bg10, bg11, bg12, bg13, bg14, today;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          percentage = response.quadrant.percentage;
                          sections = response.sections.reduce(function (messages, section) {
                            return [].concat(messages, section.subsections);
                          }, []);
                          pdf = new _jspdf.jsPDF();
                          width = _helpers2.pdfDoc.width, height = _helpers2.pdfDoc.height, copyInitialX = _helpers2.pdfDoc.copyInitialX, copyInitialY = _helpers2.pdfDoc.copyInitialY;
                          pdf.addFileToVFS('ProximaNova-Regular-normal.ttf', _ProximaNovaRegularNormal.proximaNovaRegular);
                          pdf.addFont('ProximaNova-Regular-normal.ttf', 'ProximaNova', 'normal');
                          pdf.addFileToVFS('ProximaNova-Bold-bold.ttf', _ProximaNovaBold.proximaNovaBold);
                          pdf.addFont('ProximaNova-Bold-bold.ttf', 'ProximaNova', 'bold');
                          bg1 = new Image();
                          bg1.src = _newPage["default"];
                          pdf.addImage(bg1, 'JPG', 0, 0, width, height);
                          (0, _helpers2.setSubHeadingFont)(pdf, '#000');
                          pdf.text(name, copyInitialX, height - 15);
                          (0, _helpers2.setSubHeadingFont)(pdf, '#000', 'normal');
                          pdf.text(percentage.toFixed(1) + "%", copyInitialX + pdf.getTextDimensions(name + "  ").w, height - 15);
                          pdf.addPage();
                          bg2 = new Image();

                          if ((0, _helpers.isNZHelix)()) {
                            bg2.src = _newPage0280Nz["default"];
                          } else {
                            bg2.src = _newPage2["default"];
                          }

                          pdf.addImage(bg2, 'JPG', 0, 0, width, height); // PAGE 3

                          currentY = copyInitialY;
                          pdf.addPage();
                          bg3 = new Image();
                          bg3.src = _newPage3["default"];
                          pdf.addImage(bg3, 'JPG', 0, 0, width, height);
                          section = sections.find(function (section) {
                            return section.label === 'Premise underpinning communications';
                          });
                          (0, _helpers2.setBodyFont)(pdf, 'normal');
                          pdf.text(pdf.splitTextToSize(section.messages, width - copyInitialX - 54), copyInitialX, currentY); // PAGE 4

                          pdf.addPage();
                          bg4 = new Image();
                          bg4.src = _newPage4["default"];
                          pdf.addImage(bg4, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Creative Strategy';
                          });
                          _context.next = 35;
                          return (0, _helpers2.genSubIntroOrderedList)(pdf, section, currentY, '#000');

                        case 35:
                          currentY = _context.sent;
                          // PAGE 5
                          pdf.addPage();
                          bg5 = new Image();
                          bg5.src = _newPage5["default"];
                          pdf.addImage(bg5, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Message Promise';
                          });
                          _context.next = 44;
                          return (0, _helpers2.genSubOrderedList)(pdf, section, currentY);

                        case 44:
                          currentY = _context.sent;
                          // PAGE 6
                          pdf.addPage();
                          bg6 = new Image();
                          bg6.src = _newPage6["default"];
                          pdf.addImage(bg6, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Value Proposition';
                          });
                          _context.next = 53;
                          return (0, _helpers2.genSubOrderedList)(pdf, section, currentY);

                        case 53:
                          currentY = _context.sent;
                          // PAGE 7
                          pdf.addPage();
                          bg7 = new Image();
                          bg7.src = _newPage7["default"];
                          pdf.addImage(bg7, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Brand Voice';
                          });
                          _context.next = 62;
                          return (0, _helpers2.genSubIntroOrderedList)(pdf, section, currentY, '#fff');

                        case 62:
                          currentY = _context.sent;
                          // PAGE 8
                          pdf.addPage();
                          bg8 = new Image();
                          bg8.src = _newPage8["default"];
                          pdf.addImage(bg8, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Key Triggers';
                          });
                          _context.next = 71;
                          return (0, _helpers2.genSubUnorderedList)(pdf, section, currentY);

                        case 71:
                          currentY = _context.sent;

                          if ((0, _helpers.isNZHelix)()) {
                            _context.next = 86;
                            break;
                          }

                          pdf.addPage();
                          bg9 = new Image();
                          bg9.src = _newPage9["default"];
                          pdf.addImage(bg9, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Creative Prerequisites';
                          });
                          _context.next = 81;
                          return (0, _helpers2.genSubUnorderedList)(pdf, section, currentY, null, true);

                        case 81:
                          currentY = _context.sent;
                          section = sections.find(function (section) {
                            return section.label === 'Message prerequisites';
                          });
                          _context.next = 85;
                          return (0, _helpers2.genSubUnorderedList)(pdf, section, currentY, null, true);

                        case 85:
                          currentY = _context.sent;

                        case 86:
                          // PAGE 10
                          pdf.addPage();
                          bg10 = new Image();

                          if ((0, _helpers.isNZHelix)()) {
                            bg10.src = _newPage1080Nz["default"];
                          } else {
                            bg10.src = _newPage10["default"];
                          }

                          pdf.addImage(bg10, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Advertising Tone & Style';
                          });
                          _context.next = 94;
                          return (0, _helpers2.genSubIntroOrderedList)(pdf, section, currentY);

                        case 94:
                          currentY = _context.sent;
                          // PAGE 11
                          pdf.addPage();
                          bg11 = new Image();

                          if ((0, _helpers.isNZHelix)()) {
                            bg11.src = _newPage1180Nz["default"];
                          } else {
                            bg11.src = _newPage11["default"];
                          }

                          pdf.addImage(bg11, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Key Drivers';
                          });
                          _context.next = 103;
                          return (0, _helpers2.genSubOrderedList)(pdf, section, currentY, '#fff');

                        case 103:
                          currentY = _context.sent;
                          // PAGE 12
                          pdf.addPage();
                          bg12 = new Image();

                          if ((0, _helpers.isNZHelix)()) {
                            bg12.src = _newPage1280Nz["default"];
                          } else {
                            bg12.src = _newPage12["default"];
                          }

                          pdf.addImage(bg12, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Hot Buttons';
                          });
                          _context.next = 112;
                          return (0, _helpers2.genSubOrderedList)(pdf, section, currentY);

                        case 112:
                          currentY = _context.sent;
                          // PAGE 13
                          pdf.addPage();
                          bg13 = new Image();

                          if ((0, _helpers.isNZHelix)()) {
                            bg13.src = _newPage1380Nz["default"];
                          } else {
                            bg13.src = _newPage13["default"];
                          }

                          pdf.addImage(bg13, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Turn Offs';
                          });
                          _context.next = 121;
                          return (0, _helpers2.genSubOrderedList)(pdf, section, currentY);

                        case 121:
                          currentY = _context.sent;
                          // PAGE 14
                          pdf.addPage();
                          bg14 = new Image();

                          if ((0, _helpers.isNZHelix)()) {
                            bg14.src = _newPage1480Nz["default"];
                          } else {
                            bg14.src = _newPage14["default"];
                          }

                          pdf.addImage(bg14, 'JPG', 0, 0, width, height);
                          currentY = copyInitialY;
                          section = sections.find(function (section) {
                            return section.label === 'Message Helix Personas';
                          }); //$FlowFixMe

                          if (!(indexThreshold !== null && indexThreshold > 0)) {
                            _context.next = 132;
                            break;
                          }

                          _context.next = 131;
                          return (0, _helpers2.genSubTitle)(pdf, //$FlowFixMe
                          "Index > " + indexThreshold, currentY);

                        case 131:
                          currentY = _context.sent;

                        case 132:
                          _context.next = 134;
                          return (0, _helpers2.genPersonasList)(pdf, section, currentY, '#fff', //$FlowFixMe
                          indexThreshold > 0);

                        case 134:
                          currentY = _context.sent;
                          today = new Date().toLocaleDateString().split('/').join('');
                          pdf.save("RoyMorgan_CreativeBrief_" + name.replace(/\s/, '') + "-" + today + ".pdf");

                        case 137:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handlePDFGen.apply(this, arguments);
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    className: "ui inverted button message-stream--pdf-link",
    onClick: handlePDFGen
  }, "PDF", /*#__PURE__*/_react["default"].createElement(_InlineSvg["default"], {
    name: "file"
  })));
}

var _default = PDFHandler;
exports["default"] = _default;